export function addDataAnalyticsToRteLinks(html: string): string {
  const defaultAnalytics = 'spotlight-item-click'

  const container = document.createElement('div')
  container.innerHTML = html

  container.querySelectorAll('a').forEach(a => {
    const val = a.getAttribute('data-analytics')
    if (!val) a.setAttribute('data-analytics', defaultAnalytics)
  })

  return container.innerHTML
}
